import { render, staticRenderFns } from "./ItemCategoryTabOverview.vue?vue&type=template&id=b5f4a940&scoped=true&"
import script from "./ItemCategoryTabOverview.vue?vue&type=script&lang=js&"
export * from "./ItemCategoryTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./ItemCategoryTabOverview.vue?vue&type=style&index=0&id=b5f4a940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f4a940",
  null
  
)

export default component.exports